import type { ActionTaskPlatform } from '@/features/tasks/types/actionTaskDetail'

type ActionDetailsPayload = {
  links?: unknown
  app_store_url?: string
  google_play_url?: string
}

function readString(value: unknown): string {
  return typeof value === 'string' ? value.trim() : ''
}

export function readActionPlatforms(
  actionDetails: unknown
): ActionTaskPlatform[] {
  if (!actionDetails || typeof actionDetails !== 'object') {
    return []
  }

  const details = actionDetails as ActionDetailsPayload
  if (Array.isArray(details.links)) {
    const kinds = new Set(
      details.links.map(link =>
        readString((link as { kind?: unknown } | null)?.kind).toLowerCase()
      )
    )
    // A universal link opens whichever store the phone has.
    const universal = kinds.has('universal')
    return (['app_store', 'google_play'] as const).filter(
      platform => universal || kinds.has(platform)
    )
  }

  const fallback: ActionTaskPlatform[] = []
  if (readString(details.app_store_url)) {
    fallback.push('app_store')
  }
  if (readString(details.google_play_url)) {
    fallback.push('google_play')
  }
  return fallback
}
